import { createApp } from "vue";
import router from "./routers/index";
import App from "./App.vue";
import ElementPlus from "element-plus";
import * as Icons from "@element-plus/icons-vue";
import "@/assets/styles/element/reset.scss";
import locale from "element-plus/es/locale/lang/zh-cn";
import { createPinia } from "pinia";
import VxeTable from "vxe-table";
import VueVideoPlayer from '@videojs-player/vue'

import "vxe-table/lib/style.css";
import "./style.css";
import "@/assets/styles/katex.scss";
import "@/assets/styles/highlightCode.scss";
import 'video.js/dist/video-js.css'
// 组件
import TopBar from "@/components/TopBar/index.vue";

const pinia = createPinia();

const app = createApp(App);

app.use(VueVideoPlayer)
app.component("TopBar", TopBar);

Object.keys(Icons).forEach((key) => {
  app.component(key, Icons[key as keyof typeof Icons]);
});

// app.config.errorHandler = errorHandler;

app
  .use(ElementPlus, { locale })
  .use(VxeTable)
  .use(router)
  .use(pinia)
  .mount("#app");
